import React, { useState, useEffect } from 'react';
import "./SupplierFilters.css";
import ExecuteAxios from "../../../../Components/ExecuteAxios/ExecuteAxios";
import ComboBox from 'Components/ComboBox/ComboBox';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import InputField from 'Components/Input/InputField';
import Button from 'Components/Button/Button';
import Panel from 'Components/Panel/Panel';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import useDebouncedValue from 'Components/UseDebouncedValue/useDebouncedValue';

const SupplierFilters = ({
    onUpdateSupplierIdSelected,
    supplierIdSelected,
    onUpdateSuppliers,
    reloadListSupplier,
    onUpdateReloadListSupplier
}) => {

    const [dsSupplier, setDsSupplier] = useState();
    const debouncedDsSupplier = useDebouncedValue(dsSupplier);
    const [isActive, setIsActive] = useState('S');

    const PanelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '20%',
        maxHeight: '20%',
        borderBottom: '2px solid rgb(204, 204, 204)'
    };

    async function filterSupplier() {
        const parameters = {
            supplierName: dsSupplier,
            isActive: isActive
        };
        const suppliers = await ExecuteAxios.api('get', `/supplier/get-supplier-grid/`, { params: parameters })
        onUpdateSuppliers(suppliers);
        RemoveIdsNotFound.remove(suppliers, onUpdateSupplierIdSelected, supplierIdSelected)
    }

    function isActiveSetter() {
        return setIsActive(isActive === 'S' ? 'N' : 'S')
    }

    useEffect(() => {
        filterSupplier()
    }, [debouncedDsSupplier, isActive])

    useEffect(() => {
        if (reloadListSupplier) {
            filterSupplier()
        }
        onUpdateReloadListSupplier(false)
    }, [reloadListSupplier])

    return (
        <Panel style={PanelListStyle}
            titlePage={'Filtros fornecedor'}
            canViewCRUD={true}
        >
            <LoadingIndicator loaded={true}>
                <div id='first-colum-filter-supplier'>
                    <div id='filter-atributtes'>
                        <div id='supplier-filter'>
                            <span className='span-supplier-filter'>Fornecedor</span>
                            <InputField
                                setAttribute={setDsSupplier}
                                value={dsSupplier}
                                style={{ width: '150px' }}
                            />
                        </div>

                        <div id='supplier-filter'>
                            <span className='span-supplier-filter'>Somente ativos</span>
                            <InputField
                                setAttribute={(event) => isActiveSetter(event)}
                                value={isActive}
                                checked={isActive === 'S'}
                                readOnly={false}
                                disabled={false}
                                type="checkbox"
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                </div>
            </LoadingIndicator>
        </Panel>
    );
}
export default SupplierFilters;